/*
https://vuex.vuejs.org/guide/
https://markus.oberlehner.net/blog/combining-graphql-and-vuex/
https://github.com/vuejs/vuex/tree/dev/examples
*/

import { API, Auth } from "aws-amplify";
import { createPlayer, updatePlayerRestricted, createPlayerRestricted } from "../graphql/mutations";
import { getPlayer } from "../graphql/queries";

const state = {
  /** @type {{id,name}} */
  player: null,
  isAuthenticated: false,
};

const getters = {
  isPlayerLoggedIn(state) {
    return state.isAuthenticated && state.player != null;
  },
};

const actions = {
  async onCongnitoAuthStateChange({ commit, state, dispatch }, authenticated) {
    console.log(`onCongnitoAuthStateChange > auth: ${authenticated}.`);
    if (authenticated === state.isAuthenticated) return;

    commit("setIsAuthenticated", authenticated);
    if (authenticated) await dispatch("loadPlayer");
    else commit("setPlayer", null);
  },
  async loadPlayer({ commit }) {
    commit("setIsLoading", true, { root: true });

    // Get authenticated user

    const user = await Auth.currentAuthenticatedUser();
    console.log(`Current user -> Username: ${user.username}`); //, user: ${JSON.stringify(user)}`);

    // Attempt to load player from AppSync

    let playerData = await getPlayerById(user.username);

    if (playerData !== null) {
      commit("setPlayer", playerData);
    } else {
      // Player didn't exist, create the record

      console.log(`Player doesn't exist. Creating for user ${user.username}`);
      try {
        await API.graphql({
          query: createPlayer,
          variables: {
            input: {
              id: user.username,
              name: user.attributes.name,
              purpose: "score",
              restricted: {
                id: user.username,
              },
            },
          },
        });
      } catch (error) {
        console.error(
          `Error creating Player record for ${user.username}: ${JSON.stringify(error)}`
        );
      }

      // Now load player data
      commit("setPlayer", await getPlayerById(user.username));
    }
    commit("setIsLoading", false, { root: true });
  },

  async updateStrava({ commit, state }, { scope, accessToken, refreshToken, expiry }) {
    let res = null;
    try {
      res = await API.graphql({
        query: (state.player.restricted) ? updatePlayerRestricted : createPlayerRestricted,
        variables: {
          input: {
            id: state.player.id,
            stravaAccessToken: accessToken,
            stravaRefreshToken: refreshToken,
            stravaScope: scope,
          },
        },
      });
    } catch (error) {
      console.error(
        `${state.player.restricted ? 'Update' : 'Create'}PlayerRestricted error: ${JSON.stringify(error)}`
      );
    }
    if (res !== null) {
      console.log(
        `${
          state.player.restricted ? "Update" : "Create"
        }PlayerRestricted response: ${JSON.stringify(res)}`
      );
    }
    commit("setStrava", {
      scope: scope,
      accessToken: accessToken,
      refreshToken: refreshToken,
      expiry: expiry,
    });
  },
};

const mutations = {
  setPlayer(state, player) {
    state.player = player;
  },
  setIsAuthenticated(state, isAuthenticated) {
    state.isAuthenticated = isAuthenticated;
  },
  setStrava(state, { scope, accessToken, refreshToken, expiry }) {
    if (!state.player.restricted) state.player.restricted = {};
    state.player.restricted.stravaAccessToken = accessToken;
    state.player.restricted.stravaRefreshToken = refreshToken;
    state.player.restricted.stravaScope = scope;
    state.player.restricted.stravaTokenExpiresAt = expiry;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

async function getPlayerById(id) {

    let res = null;
    try {
      res = await API.graphql({
        query: getPlayer,
        variables: { id: id },
      });
    } catch (error) {
      console.error(`GetPlayer error: ${JSON.stringify(error)}`);
    }
    if (res !== null) {
      console.log(`GetPlayer response: ${JSON.stringify(res)}`);
      if (res.data.getPlayer !== null) {
        return res.data.getPlayer;
      }
    }
    return null;
}